module.exports = __webpack_public_path__ + "media/images/cards/cc-stripe-16774769459fe9ef3cd11bd49a534d94.svg";